import { render, staticRenderFns } from "./estranged.vue?vue&type=template&id=086850f4&scoped=true&"
import script from "./estranged.vue?vue&type=script&lang=js&"
export * from "./estranged.vue?vue&type=script&lang=js&"
import style0 from "./estranged.vue?vue&type=style&index=0&id=086850f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086850f4",
  null
  
)

export default component.exports